export const POPULARITY_QUERY_DATE_FORMAT = 'd/M/yyyy'
